var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader-style"},[(_vm.showLoader)?_c('rotate-square5',{staticClass:"m-auto"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }